import {Divider, Row, Col, Space, Table} from "antd";
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import http from "../../http";
import {useTranslation} from "react-i18next";
import DataTable from "../../components/DataTable/DataTable";
import CustomTimeline from "../../components/Timeline/Timeline";


const VRSServerDetailPage=(props)=>{
    const navigate = useNavigate();
    const location = useLocation();
    const {state} = location;
    const [loading, setLoading] = useState(false);
    const [vrs, setVRS] = useState(state?.vrs);
    const [isValidState, setValidState] = useState(!!state?.vrs);
    const { t } = useTranslation();
    const historyColumns = [
        {
            title: t('vrs_usage_history_list_col1'),
            dataIndex: 'machine_name',
            key: 'machineName',
        },
        {
            title: t('vrs_usage_history_list_col2'),
            dataIndex: 'start_date',
            key: 'startDate',
        },
        {
            title: t('vrs_usage_history_list_col3'),
            dataIndex: 'end_date',
            key: 'endDate',
        },
        {
            title: t('vrs_usage_history_list_col4'),
            dataIndex: 'status_text',
            key: 'statusText',
            render: (text)=>(
                <div style={{color: text === 'active_label' ? '#079327': '#DC000C'}}>{t(text)}</div>
            )
        },
    ]

const machineSchedules = [
        {
            "id": 100012,
            "group": 1,
            "title": vrs.vrs_schedule.machine,
            "start_time": vrs.vrs_schedule.start_date,
            "end_time": vrs.vrs_schedule.end_date,
            "color": '#377EF3',
        }
    ]
    const fetchVRSData=()=>{
        http.get(`/api/v1/machines/vrs/${vrs?.id}/?`).then((resp)=>{
            setLoading(false);
            setVRS(resp.data);
        }).catch((err)=>{
            setLoading(false);
        })
    }

    useEffect(()=>{
        if(!state){
            navigate('/content_not_found',{replace: true})
        }
        if(isValidState) {
            fetchVRSData()
        }
    }, [state])

    const buildBreadcrumbs=()=>{
        let breadcrumbs = [];
        if(state.breadcrumbs){
            state.breadcrumbs.map((item, index)=>{
                breadcrumbs.push(
                    <><Link to={item.to} state={item.state} key={index}>{item.title}</Link> > </>
                )
            })
            breadcrumbs.push(<>{vrs.name}</>)
            return breadcrumbs;
        }
        return <><Link to={'/vrs_servers'}>{t('vrs_server_listpage_title')}  </Link> >  {vrs.name}</>;
    }
    if(isValidState) {
        return (
            <>
                <div style={{overflowY: 'auto', overflowX: 'hidden', width: '100%', height: '100%'}}>
                    <Row style={{height: '5%', color: "black", fontWeight: 'bold', justifyContent: 'space-between'}}>
                        <Col>
                            <Space>{buildBreadcrumbs()}</Space>
                        </Col>
                    </Row>
                    <Row style={{display: 'flex', flexDirection: 'column'}}>
                        <Col span={10} style={{display:'flex'}}>
                            <Col>
                                <Col style={{lineHeight: '1.5rem'}}><h1>{vrs.name}</h1></Col>
                                <Col>{t('vrs_server_serverid_field')} : {vrs.server_id}</Col>
                                <Col>{t('vrs_server_provider_field')} : {vrs.provider}</Col>
                                <Col>{t('vrs_server_url_field')} : {vrs.url}</Col>
                                <Col>{t('vrs_server_port_field')} : {vrs.port}</Col>
                                <Col>{t('vrs_server_password_field')} : {vrs.password}</Col>
                                <Col>{t('vrs_server_mountpoint_field')} : {vrs.mountpoint}</Col>
                            </Col>
                            <Divider type='vertical'/>
                            <Col>
                                <Col style={{lineHeight: '1.5rem'}}>
                                    <h1 style={{ visibility: 'hidden' }}>{t('machine_detail_data2')}</h1>
                                </Col>
                                 <Col>{t('vrs_server_active_machine')} : {vrs.vrs_schedule.machine}</Col>
                            </Col>
                        </Col>
                    </Row>
                    <Row style={{marginTop: '50px'}}>
                        <CustomTimeline data={machineSchedules} title={t('vrs_active_schedule_gantt_title')}/>
                    </Row>
                    <Divider/>
                    <Divider style={{marginTop: '10px'}}/>
                    <Row style={{display: 'flex', flexDirection: 'column'}}>
                        <Col>
                            <p style={{fontWeight: "bold", fontSize: "800"}}> {t('vrs_usage_history_list_title')} </p>
                        </Col>
                        <Col>
                            <DataTable
                                locale={{emptyText: t('table_no_data_text')}}
                                sticky={true}
                                loading={loading}
                                data={vrs.histories}
                                columns={historyColumns}
                                pagination={true}
                            />
                        </Col>
                    </Row>
                </div>
            </>

        )
    }
    else{
        return null;
    }
}

export default VRSServerDetailPage;
